import { Companion_getInstancel4ymxmn2l08f as Companion_getInstance } from '../../../../../../lightning-server-core-shared/com/lightningkite/lightningserver/HttpMethod.mjs';
import { StringCompanionObject_instance2dx16b5pp3v3z as StringCompanionObject_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import { serializer1x79l67jvwntn as serializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  Companion_instance346bdrozb6eyq as Companion_instance,
  Companion_instance1xo6qhmbc85vh as Companion_instance_0,
  Companion_instance24h6kgvz9f2xn as Companion_instance_1,
} from './proofModels.mjs';
import {
  get_via38yy5q0f9oxer as get_via,
  get_property364tzqq3z832r as get_property,
  Email1w7ox5oeijz9q as Email,
  get_via1qy3fim7enjl0 as get_via_0,
  get_property3fywtt2wxtx70 as get_property_0,
  TimeBasedOTP8rvmui1ob933 as TimeBasedOTP,
  get_via1akmqcvk1uw2r as get_via_1,
  Password2oz6lme4sxm35 as Password,
  get_via1dsogpg00hdlv as get_via_2,
  BackupCode2jc2vekqp19f0 as BackupCode,
} from './ProofClientEndpoints.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var EmailClass;
function Email_0() {
  if (EmailClass === VOID) {
    class $ {
      constructor(fetcher, subpath) {
        this.fetcher_1 = fetcher;
        this.subpath_1 = subpath;
      }
      *beginEmailOwnershipProof_z98tf3_k$(input, $completion) {
        return yield* this.fetcher_1.invoke_vgogw6_k$(this.subpath_1 + '/start', Companion_getInstance().POST_1, serializer(StringCompanionObject_instance), input, serializer(StringCompanionObject_instance), $completion);
      }
      *proveEmailOwnership_zd3jgf_k$(input, $completion) {
        return yield* this.fetcher_1.invoke_vgogw6_k$(this.subpath_1 + '/prove', Companion_getInstance().POST_1, Companion_instance.serializer_9w0wvi_k$(), input, Companion_instance_0.serializer_9w0wvi_k$(), $completion);
      }
    }
    protoOf($).get_via_18itzv_k$ = get_via;
    protoOf($).get_property_msvula_k$ = get_property;
    initMetadataForClass($, 'Email', VOID, VOID, [Email()], [1]);
    EmailClass = $;
  }
  return EmailClass;
}
var TimeBasedOTPClass;
function TimeBasedOTP_0() {
  if (TimeBasedOTPClass === VOID) {
    class $ {
      constructor(fetcher, subpath) {
        this.fetcher_1 = fetcher;
        this.subpath_1 = subpath;
      }
      *proveOTP_hnj5ta_k$(input, $completion) {
        return yield* this.fetcher_1.invoke_vgogw6_k$(this.subpath_1 + '/prove', Companion_getInstance().POST_1, Companion_instance_1.serializer_9w0wvi_k$(), input, Companion_instance_0.serializer_9w0wvi_k$(), $completion);
      }
    }
    protoOf($).get_via_18itzv_k$ = get_via_0;
    protoOf($).get_property_msvula_k$ = get_property_0;
    initMetadataForClass($, 'TimeBasedOTP', VOID, VOID, [TimeBasedOTP()], [1]);
    TimeBasedOTPClass = $;
  }
  return TimeBasedOTPClass;
}
var PasswordClass;
function Password_0() {
  if (PasswordClass === VOID) {
    class $ {
      constructor(fetcher, subpath) {
        this.fetcher_1 = fetcher;
        this.subpath_1 = subpath;
      }
      *provePasswordOwnership_n5u26d_k$(input, $completion) {
        return yield* this.fetcher_1.invoke_vgogw6_k$(this.subpath_1 + '/prove', Companion_getInstance().POST_1, Companion_instance_1.serializer_9w0wvi_k$(), input, Companion_instance_0.serializer_9w0wvi_k$(), $completion);
      }
    }
    protoOf($).get_via_18itzv_k$ = get_via_1;
    protoOf($).get_property_msvula_k$ = get_property_0;
    initMetadataForClass($, 'Password', VOID, VOID, [Password()], [1]);
    PasswordClass = $;
  }
  return PasswordClass;
}
var BackupCodeClass;
function BackupCode_0() {
  if (BackupCodeClass === VOID) {
    class $ {
      constructor(fetcher, subpath) {
        this.fetcher_1 = fetcher;
        this.subpath_1 = subpath;
      }
      *proveBackupCode_juqyr2_k$(input, $completion) {
        return yield* this.fetcher_1.invoke_vgogw6_k$(this.subpath_1 + '/prove', Companion_getInstance().POST_1, Companion_instance_1.serializer_9w0wvi_k$(), input, Companion_instance_0.serializer_9w0wvi_k$(), $completion);
      }
    }
    protoOf($).get_via_18itzv_k$ = get_via_2;
    protoOf($).get_property_msvula_k$ = get_property_0;
    initMetadataForClass($, 'BackupCode', VOID, VOID, [BackupCode()], [1, 0]);
    BackupCodeClass = $;
  }
  return BackupCodeClass;
}
//region block: exports
export {
  BackupCode_0 as BackupCode3usy9yc0uco6j,
  Email_0 as Email2czi041hozwks,
  Password_0 as Password1ydqms6ppq4qq,
  TimeBasedOTP_0 as TimeBasedOTP29tckvyi0qgqr,
};
//endregion

//# sourceMappingURL=LiveProofClientEndpoints.mjs.map
